module.exports = __webpack_public_path__ + "static/apple-icon-152x152-45e72b3b10efe82102a4cbffb3157de0.png";